
<!-- <nav aria-label="Page navigation" *ngIf="_pageData">            
    <ul class="pagination">

        <li class="page-item"><span class="page-info">{{ 'PAGINATION.NUMBER_OF_PAGES_SELECT' | translate }}:</span></li>
        <li class="page-item">
            <select placeholder="{{ 'PAGINATION.SELECT' | translate }}" class="number-of-pages-select" (change)="selectDefaultValue($event.target.value)">
                <option *ngFor="let item of numberOfPagesSelect" [value]="item.value" [selected]="item.default">{{ item.value }}</option>
            </select>
        </li>
        <li class="page-item"><span class="page-info">{{ from }}-{{ to }}</span></li>
        <li class="page-item"><span class="page-info">{{ 'PAGINATION.FROM' | translate }}</span></li>
        <li class="page-item"><span class="page-info">{{ total }}</span></li>
        <li class="page-item">
            <button class="page-link left" (click)="navPage('prev')" [disabled]="_pageData.currentPage == 1">
                <span>
                    <i class="bi bi-chevron-left"></i>
                </span>
            </button>
        </li>
        <li class="page-item">
            <button class="page-link right" (click)="navPage('next')" [disabled]="_pageData.currentPage == _pageData.numberOfPages">
                <span>
                    <i class="bi bi-chevron-right"></i>
                </span>
            </button>
        </li>
        <li class="page-item">
            <button class="page-link refresh" (click)="firstPage()" [disabled]="_pageData.currentPage == 1"> 
                <span>
                    <i class="bi bi-arrow-clockwise"></i>
                </span>
            </button>
        </li>
    </ul>
    
</nav> -->

<div class="d-md-block nav-buffer"></div>

<nav aria-label="Page navigation" *ngIf="_pageData && _pageData.count > 10">
    <div class="pagination">
        <div class="pagination-select">
            <div class="pagination-select_item">
                <span class="select-item_info">Показать</span>
            </div>
            <div class="pagination-select_item">
                <div class="select-item_inner">

                    <div class="input-group">
                        <!-- onfocus='this.size=4;' onblur='this.size=0;' onchange='this.size=1; this.blur();'  -->
                        <select class="custom-select" id="inputGroupSelect01" (change)="selectDefaultValue($event.target.value)" aria-label="Example select with button addon">
                          <option class="numberSelect-item" *ngFor="let item of numberOfPagesSelect" [value]="item.value" [selected]="item.default">{{ item.value }}</option>
                        </select>
                        <!-- <ng-select class="custom-lang" bindLabel="value"
                        bindValue="value"  [items]="numberOfPagesSelect" formControlName="defaultItem"
                        [clearable]="false" appendTo="body">
                        </ng-select> -->
                          <!-- <ng-select  
                            class="custom"
                           
                            bindLabel="value"
                            bindValue="value"
                            [items]="numberOfPagesSelect"
                            [searchable]="false"
                            (change)="selectDefaultValue($event.target.value)" [(ngModel)]="defaultItem"
                            >
                            <ng-template ng-option-tmp  let-item="item">
                                <div title="{{ item.value }}" (change)="selectDefaultValue($event.target.value)" [(ngModel)]="defaultItem"> {{ item.value }} </div>
                            </ng-template>
                        </ng-select> -->
                    </div>
                    <!-- <select placeholder="{{ 'PAGINATION.SELECT' | translate }}" class="select-item_numberSelect" (change)="selectDefaultValue($event.target.value)">
                        <option class="numberSelect-item" *ngFor="let item of numberOfPagesSelect" [value]="item.value" [selected]="item.default">{{ item.value }}</option>
                    </select> -->
                </div>
            </div>
        </div>

        <div class="pagination-currentPage">
            <div class="pagination-currentPage_nav">

                <ngb-pagination [collectionSize]="_pageData.count" [pageSize]="_pageData.size" [(page)]="_pageData.currentPage" [maxSize]="5" aria-label="Custom pagination">
                    <ng-template ngbPaginationPrevious>
                        <div class="" (click)="navPage('prev')">
                            <!-- <button class="currentPage-pages_item currentPage-nav"> -->
                                <svg-icon src="/assets/images/icons/chevron-left.svg" [stretch]="true"
                                [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                            <!-- </button> -->
                        </div>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <div class=""  (click)="navPage('next')">
                            <!-- <button class="currentPage-pages_item currentPage-nav"> -->
                                <svg-icon src="/assets/images/icons/chevron-right.svg" [stretch]="true"
                                [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                            <!-- </button> -->
                        </div>
                    </ng-template>
                    <ng-template ngbPaginationEllipsis>...</ng-template>
                    <ng-template ngbPaginationNumber let-page>
                        <div (click)="navPage('selectPage', page)">
                            {{ page }}
                        </div>
                        </ng-template>
                </ngb-pagination>

                <!-- <button class="currentPage-pages_item currentPage-nav" (click)="navPage('prev')" >
                    <i><img src="/assets/images/icons/chevron-left.svg"></i>
                    <svg-icon src="/assets/images/icons/chevron-left.svg" [stretch]="true"
                    [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                </button>
                <div class="currentPage-pages">

                    <ul class="currentPage-pages" *ngFor="let page of pageMinPagination; let i = index;">
                        <li><button (click)="navPage('selectPage', page)" class="currentPage-pages_item">{{page}}</button></li>
                    </ul>
                    <ul class="currentPage-pages">
                        <li class="currentPage-pages_item dots">...</li>
                        <li><button class="currentPage-pages_item">{{pages.length}}</button></li>
                    </ul>

                </div>
                <button class="currentPage-pages_item currentPage-nav" (click)="navPage('next')" [disabled]="_pageData.currentPage == _pageData.numberOfPages">
                    <i><img src="/assets/images/icons/chevron-right.svg"></i>
                    <svg-icon src="/assets/images/icons/chevron-right.svg" [stretch]="true"
                    [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                </button> -->
            </div>
        </div>

        <div class="pagiantion-choice">
            <span class="pagiantion-choice_info">Перейти на страницу</span>

            <div class="pagiantion-choice_page">
                <form action="" [formGroup]="form">
                    <input formControlName="selectPage" id="selectPage" class="choice-page">
                </form>
            </div>
            <button class="currentPage-pages_item currentPage-nav" (click)="getSelectPage()">
                <!-- <button class="currentPage-nav choice-page_action" (click)="navPage('selectPage')"> -->
                    <!-- <i><img src="/assets/images/icons/chevron-right.svg"></i> -->
                    <svg-icon src="/assets/images/icons/chevron-right.svg" [stretch]="true"
                    [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
            </button>
        </div>

    </div>
</nav>
